var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('dashboard-layout', {
    attrs: {
      "title": "공고 지원현황",
      "fullHeight": ""
    }
  }, [_c('template', {
    slot: "contents"
  }, [_vm.items.length ? [_c('div', {
    staticClass: "applied-cards"
  }, _vm._l(_vm.items, function (item) {
    var _item$company, _item$company$logo, _item$company2, _item$company2$logo, _item$company3, _item$company4, _item$recruitment, _item$recruitment2, _item$recruitment3, _item$recruitment3$em, _item$recruitment4, _item$recruitment5;
    return _c('v-card', {
      key: item._id,
      staticClass: "applied-card",
      attrs: {
        "rounded": "lg",
        "outlined": ""
      }
    }, [_c('v-row', {
      attrs: {
        "no-gutters": ""
      }
    }, [_c('v-col', {
      staticClass: "border-md-end min-w-md-200px min-w-lg-280px",
      attrs: {
        "cols": "12",
        "md": "auto"
      }
    }, [_c('v-layout', {
      staticClass: "w-100 h-100 pa-20",
      attrs: {
        "justify-center": "",
        "align-center": ""
      }
    }, [_c('v-img', {
      attrs: {
        "aspect-ratio": 166 / 36,
        "width": "166",
        "height": "36",
        "max-width": "166",
        "contain": "",
        "src": item === null || item === void 0 ? void 0 : (_item$company = item.company) === null || _item$company === void 0 ? void 0 : (_item$company$logo = _item$company.logo) === null || _item$company$logo === void 0 ? void 0 : _item$company$logo.url
      }
    }, [_c('v-fade-transition', [_c('v-overlay', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: !(item !== null && item !== void 0 && (_item$company2 = item.company) !== null && _item$company2 !== void 0 && (_item$company2$logo = _item$company2.logo) !== null && _item$company2$logo !== void 0 && _item$company2$logo.url),
        expression: "!item?.company?.logo?.url"
      }],
      attrs: {
        "absolute": "",
        "light": "",
        "color": "white"
      }
    }, [_c('image-overlay', [_vm._v(_vm._s(item === null || item === void 0 ? void 0 : (_item$company3 = item.company) === null || _item$company3 === void 0 ? void 0 : _item$company3.name))])], 1)], 1)], 1)], 1)], 1), _c('v-col', {
      staticClass: "applied-card__info",
      attrs: {
        "cols": "12",
        "md": ""
      }
    }, [_c('div', {
      staticClass: "pa-20 pa-md-24"
    }, [_c('v-row', {
      staticClass: "row--large",
      attrs: {
        "align": "center"
      }
    }, [_c('v-col', {
      staticClass: "applied-card__detail mb-10 mb-md-0",
      attrs: {
        "cols": "12",
        "md": ""
      }
    }, [_c('p', {
      staticClass: "page-text page-text--sm primary--text mb-4"
    }, [_vm._v(_vm._s(item === null || item === void 0 ? void 0 : (_item$company4 = item.company) === null || _item$company4 === void 0 ? void 0 : _item$company4.name))]), _c('a', {
      staticClass: "d-block page-text--lg font-wieght-medium mb-8 mb-lg-16",
      attrs: {
        "href": `/recruitments/${item === null || item === void 0 ? void 0 : (_item$recruitment = item.recruitment) === null || _item$recruitment === void 0 ? void 0 : _item$recruitment._id}`,
        "rel": "noopener noreferrer"
      }
    }, [_vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : (_item$recruitment2 = item.recruitment) === null || _item$recruitment2 === void 0 ? void 0 : _item$recruitment2.subject) + " ")]), item !== null && item !== void 0 && (_item$recruitment3 = item.recruitment) !== null && _item$recruitment3 !== void 0 && (_item$recruitment3$em = _item$recruitment3.employment) !== null && _item$recruitment3$em !== void 0 && _item$recruitment3$em.typesTexts ? _c('v-chip-group', {
      staticClass: "mb-4"
    }, _vm._l(item.recruitment.employment.typesTexts, function (text) {
      return _c('v-chip', {
        key: text,
        attrs: {
          "small": "",
          "outlined": "",
          "color": "grey-d"
        }
      }, [_c('span', {
        staticClass: "grey-6--text"
      }, [_vm._v(" " + _vm._s(text) + " ")])]);
    }), 1) : _vm._e(), _c('p', {
      staticClass: "page-text grey-6--text ellip mb-8 mb-lg-16"
    }, [_vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : (_item$recruitment4 = item.recruitment) === null || _item$recruitment4 === void 0 ? void 0 : _item$recruitment4.summary) + " ")]), _c('recruitment-view-application', {
      attrs: {
        "application": item === null || item === void 0 ? void 0 : (_item$recruitment5 = item.recruitment) === null || _item$recruitment5 === void 0 ? void 0 : _item$recruitment5.application
      }
    })], 1), _c('v-col', {
      staticClass: "mb-10 mb-md-0",
      attrs: {
        "cols": "12",
        "md": "auto"
      }
    }, [_c('div', {
      staticClass: "min-w-80px"
    }, [_c('p', {
      staticClass: "page-text--sm grey-9--text mb-4"
    }, [_vm._v("상태")]), _c('v-layout', {
      attrs: {
        "align-center": ""
      }
    }, [_c('div', {
      staticClass: "mr-4"
    }, [(item === null || item === void 0 ? void 0 : item.state) == 'ON_WRITING' ? _c('i', {
      staticClass: "icon icon-dot icon-dot--green"
    }) : (item === null || item === void 0 ? void 0 : item.state) == 'IS_APPLIED' ? _c('i', {
      staticClass: "icon icon-dot icon-dot--primary"
    }) : (item === null || item === void 0 ? void 0 : item.state) == 'IS_REVOKED' ? _c('i', {
      staticClass: "icon icon-dot icon-dot--grey"
    }) : (item === null || item === void 0 ? void 0 : item.state) == 'ON_RECRUIT' ? _c('i', {
      staticClass: "icon icon-dot icon-dot--secondary"
    }) : _vm._e()]), _c('h5', {
      staticClass: "page-text--lg font-weight regular"
    }, [_vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : item.stateText) + " ")])])], 1)]), _c('v-col', {
      attrs: {
        "cols": "12",
        "md": "auto"
      }
    }, [_c('v-btn', {
      staticClass: "mw-lg-100px",
      attrs: {
        "disabled": item.state == _vm.APPLICATION_STATES.IS_REVOKED.value || item.state == _vm.APPLICATION_STATES.ON_RECRUIT.value,
        "outlined": "",
        "small": "",
        "block": "",
        "color": "primary"
      },
      on: {
        "click": function ($event) {
          return _vm.revoke(item);
        }
      }
    }, [_vm._v("지원취소")])], 1)], 1)], 1)])], 1)], 1);
  }), 1), _c('v-pagination', {
    attrs: {
      "value": _vm.page,
      "length": _vm.pageCount,
      "total-visible": 11,
      "color": "primary"
    },
    on: {
      "input": function (page) {
        return _vm.$router.push({
          query: Object.assign({}, _vm.$route.query, {
            page
          })
        });
      }
    }
  })] : [_c('v-layout', {
    staticClass: "w-100 h-100 grey-f7 rounded-lg pa-20",
    attrs: {
      "column": "",
      "justify-center": "",
      "align-center": ""
    }
  }, [_c('p', {
    staticClass: "page-text--lg line-height-15 text-center mb-12 mb-lg-32"
  }, [_vm._v(" 안녕하세요, 사용자님. "), _c('br'), _vm._v(" 지원한 채용공고가 없습니다. ")]), _c('v-btn', {
    attrs: {
      "href": "/recruitments",
      "text": "",
      "height": "auto",
      "color": "transparent"
    }
  }, [_c('span', {
    staticClass: "grey-9--text"
  }, [_vm._v("채용공고 보러가기")])])], 1)]], 2)], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }